import type { FC, ReactNode } from 'react'
import { Popover } from 'antd'
import type { PopoverProps } from 'antd'

interface IUserBlockPopover extends PopoverProps {
    className?: string
    placement?:
        | 'top'
        | 'left'
        | 'right'
        | 'bottom'
        | 'topLeft'
        | 'topRight'
        | 'bottomLeft'
        | 'bottomRight'
        | 'leftTop'
        | 'leftBottom'
        | 'rightTop'
        | 'rightBottom'
    content: ReactNode
    title: ReactNode
    trigger: string
}

export const UserBlockPopover: FC<IUserBlockPopover> = ({ className, ...props }) => {
    return <Popover {...props} overlayClassName={className} />
}
